import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import { API_URL } from '../config';
import { useSelector } from 'react-redux';
import EDSFooter from '../components/EDSFooter';

const Potwierdzenie_zakupu = () => {
    const history = useHistory();
    let time = [];
    let getGroup = useSelector((state) => state.repos.groups);
    const coursesHeadings = JSON.parse(localStorage.getItem('coursesHeadings'));
    const dataStart = JSON.parse(localStorage.getItem('dateToBay'));
    if(coursesHeadings && coursesHeadings.courseTime){
        let timeArr = coursesHeadings.courseTime.split(',')
        timeArr.map(((e, index) => {
            time.push({key: index, name: e})
        }))
    }
    const [res, setRes] = useState(time);

    const messegeForPay = `W każdym momencie możesz sprawdzić status swojej wpłaty klikając na zakładkę Umowy w swoim Profilu użytkownika.`;

    const proxySendURL = `${API_URL}ProxySend`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const formData = {
        type: 'Order',
        body: {
            current_LocalizationsID: -1,
            sessionID: document.location.href
                .split('Potwierdzenie_zakupu/')
                .splice(1)
                .join('')
                .split('&')[0],
        },
    };
    
    const [getStatus, setGetStatus] = useState(4);
    let globalResponse;
    const methodProxySend = () => {
        axios
            .post(proxySendURL, formData, config)
            .then((response) => {
                globalResponse = response.data.requestId;
                console.log('proxySendUrl Response', response);
                methodProxyGetMessage();
            })
            // .catch(function (error) {
            //     if (error.response.status == 401) {
            //         history.push('/Error_sesja_wygasla');
            //     } else {
            //         history.push('/error_blendy_zakladania_umowy');
            //     }
            // });
    };

    const checkPaymentStatus = (proxyGetMessageUrlResponse) => {
        if (proxyGetMessageUrlResponse.data.responseBody) {
            if (proxyGetMessageUrlResponse.data.responseBody.body.paymentStatusesDVID == 4) {
                console.log(
                    'status: ',
                    proxyGetMessageUrlResponse.data.responseBody.body.paymentStatusesDVID
                );
                setGetStatus(4);
                setTimeout(() => methodProxyGetMessage(), 5000);
            } else {
                console.log(
                    'status: ',
                    proxyGetMessageUrlResponse.data.responseBody.body.paymentStatusesDVID
                );
                setGetStatus(proxyGetMessageUrlResponse.data.responseBody.body.paymentStatusesDVID);
            }
        }
    };

    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, config)
            .then((proxyGetMessageUrlResponse) => {
                if (proxyGetMessageUrlResponse.data.recheck == false) {
                    checkPaymentStatus(proxyGetMessageUrlResponse);
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    checkPaymentStatus(proxyGetMessageUrlResponse);
                    setTimeout(() => methodProxyGetMessage(), 5000);
                }
            })
            .catch(function (error) {
                console.log(error);
                if (error.response.status == 401) {
                    history.push('/Error_sesja_wygasla');
                } else {
                    history.push('/error_blendy_zakladania_umowy');
                }
            });
    };

    useEffect(() => {
        methodProxySend();
    }, []);

    return (
        <>
            {/* <div>
                <button onClick={() => onCountClick()}>click</button>
            </div> */}
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <ProfileHeader></ProfileHeader>
                <main className="responsive-padding margin-top-64">
                    <h2 className="h2">Status:</h2>
                    <h2
                        className="paywaiting"
                        style={{ display: getStatus === 4 ? 'block' : 'none' }}
                    >
                        W trakcie realizacji
                    </h2>
                    <h2
                        className="peySuccess"
                        style={{ display: getStatus === 2 ? 'block' : 'none' }}
                    >
                        <span>Opłacona</span>
                    </h2>
                    <h2
                        className="peyanSuccess"
                        style={{ display: getStatus === 5 ? 'block' : 'none' }}
                    >
                        Odrzucona
                    </h2>
                    <div>
                        {(coursesHeadings.statusMessege)? messegeForPay:  
                        <h2 className="h2">Zapisałeś/łaś się na kurs</h2>}
                       
                        <p id="purchased-title" className="purchased__title h3 margin-top-32">
                            {coursesHeadings.courseHeadingName}, {(coursesHeadings.courseLevel)? coursesHeadings.courseLevel + ',': ''}{' '}
                            {(coursesHeadings.courseDanceStyle)? 'styl: ' + coursesHeadings.courseDanceStyle: ''}
                        </p>
                        <p className="text-large margin-top-8">
                           {(coursesHeadings.statusMessege)? '': 'Dziękujemy!'} 
                            </p>
                        <p className="text-large margin-top-32">
                            Do zobaczenia na najbliższych zajęciach!
                        </p>
                        {(coursesHeadings.statusMessege)? '':  
                        <p id="purchased-date">{'Start kursu: ' + ((new Date(coursesHeadings.startingDate) > new Date(dataStart))? coursesHeadings.startingDate: dataStart)}</p>}
                        <p id="purchased-time">
                            {'Zajęcia w dniach: ' }{' '}
                            <ul id="related-list"> 
                                {res.map((el) => (
                                    <p>{el.name}</p>
                                ))}
                            </ul>

                        </p>
                        <p className="margin-top-32">
                            {/* Harmonogram zajęć możesz zawsze sprawdzić w swoim profilu. */}
                        </p>
                    </div>
                    <div>
                        <Link to="/taniec_kurs">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-32"
                            >
                                Zapisz się na kolejny kurs
                            </a>
                        </Link>
                    </div>
                    <div className="margin-top-32">
                        <Link to="/taniec">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium"
                            >
                                Wróć do strony głównej
                            </a>
                        </Link>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Potwierdzenie_zakupu;
